import { ModalContentKey } from '@hec/models';

export const TOGGLE_MODAL = 'TOGGLE_MODAL';

export const ToggleModal = (modalContentKey: ModalContentKey, data: unknown = {}) =>
  ({ type: TOGGLE_MODAL, data: { modalContentKey, data } });
